import React from 'react';
import styled, { css } from 'styled-components';
import { GqlCollectionCardBadge } from 'types/graphql';
import { LockIconSimpleSmall } from 'src/assets/lock-icon-simple-small';
import { useFlags } from 'launchdarkly-react-client-sdk';

type CollectionBadgeProps = {
  collectionCardBadge: GqlCollectionCardBadge;
};

export const CollectionBadge = ({ collectionCardBadge }: CollectionBadgeProps): JSX.Element => {
  const { color, isExclusive, title } = collectionCardBadge;

  const flags = useFlags();
  const isExclusiveCollectionsEnabled = flags['ecommerce.exclusive-collections.rollout'] ?? false;
  const isExclusiveCollection = isExclusiveCollectionsEnabled && isExclusive;

  return (
    <Badge $color={color} $isExclusive={isExclusiveCollection}>
      {isExclusiveCollection && <LockIconSimpleSmall color='currentColor' />}
      {title}
    </Badge>
  );
};

const Badge = styled.div<{
  $color: GqlCollectionCardBadge['color'];
  $isExclusive: GqlCollectionCardBadge['isExclusive'];
}>`
  align-items: center;
  color: ${({ $color }) => $color ?? 'currentColor'};
  display: flex;
  gap: 4px;
  justify-content: var(--justify-content, flex-start);
  width: 100%;

  ${({ $isExclusive }) =>
    !$isExclusive &&
    css`
      &::before {
        background: currentColor;
        content: '';
        height: 6px;
        margin: 0 3px;
        transform: rotate(45deg);
        width: 6px;
      }
    `}

  svg {
    width: 12px;
    height: 12px;
  }
`;
